import React from "react";
import Header from "../../components/Header";
import HireCountryHero from "../../components/HireCountryHero";
import EmployerHowItWorks from "../../components/EmployerHowItWorks";
import ContactShowcase from "../../components/ContactShowcase";
import Showcase from "../../components/Showcase";
import Footer from "../../components/Footer";
import "../../styles/hire.css";

import countrydata from "../../data/countrydata";
import stackdata from "../../data/stackdata";

const HireCountry = ({ match }) => {
  const country = match.params.country;
  const skill = match.params.skill;

  const skillsName = stackdata.map((data) => data.name);

  const skillArr = stackdata.filter((data) => data.slug === skill);

  return (
    <div>
      {countrydata.indexOf(country) + 1 && skillsName.indexOf(skill) + 1 ? (
        <div>
          <div className="herobg text-white">
            <Header />
            <HireCountryHero country={country} skill={skill} />
          </div>
          <EmployerHowItWorks stack={skill} skillsName={skillsName} skill={skillArr} />
          <ContactShowcase stack={skill} />
        </div>
      ) : (
        <div>
          <div className="herobg text-white">
            <Header />
            <section className="pt-5 container text-center">
              <div className="pt-5 font-heading font-weight-bold">404!!</div>
              <div className="font-normal pb-3">Haha, you played yourself!</div>
            </section>
          </div>
          <Showcase />
        </div>
      )}
      <Footer />
    </div>
  );
};

export default HireCountry;
